export const SUPPORTED_RESOLUTIONS = {
  5: "5m",
  15: "15m",
  60: "1h",
  240: "4h",
  "1D": "1d",
};
export const LAST_BAR_REFRESH_INTERVAL = 15000; // 15 seconds
export const TV_CHART_RELOAD_INTERVAL = 15 * 60 * 1000; // 15 minutes
